import loadable from '@loadable/component';

export const DisappearingFlashMessageLoadable = loadable(
  () => import('./DisappearingFlashMessage'),
  { resolveComponent: (module) => module.DisappearingFlashMessage },
);
